export const ADD_PROGRESS = "Add Progress";
export const UPDATE_SAVING = "Update Saving";
export const DELETE_SAVING = "Delete Saving";
export const CATEGORIES_LOADING_REASON = "Loading categories…";
export const CATEGORIES_FAILED_REASON = "Categories couldn't load";
export const CASHBACK_CATEGORY_MISSING_REASON = "No Cashback income category";
